import { useTranslation } from 'react-i18next';
import { ColumnFlexContainer } from '../../../stories/atoms/containerV2/ContainerV2';
import { Animation, Animations } from '../../../stories/molecules';
import { commonTranslations } from '../../../translations';
import { useThemeContext } from '../../../global-state/themeContext';

export const FallBackComponent = () => {
  const { t } = useTranslation();
  const { mode } = useThemeContext();
  const isDarkMode = mode === 'dark';

  return (
    <ColumnFlexContainer
      key="fallback-component"
      backgroundColor={isDarkMode ? 'backgroundPaperDark' : 'white'}
      shadow
      borderRadius={[4]}
      height={[78]}
      padding={[4]}
      justifyContent="center"
      alignItems="center"
      gap={[2]}
      data-testid="error-area-view"
    >
      <Animation
        size="small"
        title={t(commonTranslations.errorText2.key, commonTranslations.errorText2.defaultValue)}
        titleType="h4"
        subtitle={t(commonTranslations.errorText3.key, commonTranslations.errorText3.defaultValue)}
        animation={Animations.SAD}
      />
    </ColumnFlexContainer>
  );
};
